import React from "react";
import { HandleOutputYellow as A, HandleOutputGreen as V, HandleOutputRed as R, HandleOutputPurple as P  } from './';
const handlesList = {A, V, R, P};

export const HandleOutputWrapper = ({handles, isConnectable, onConnect}) => {

  return (
    <>
      {
        handles.map( (x, index) => {
          const Hnd = handlesList[x];
          const radius = handles.length === 1 ? "0px 5px 5px 0px" : (index === 0 ? "0px 5px 0px 0px" : (index === (handles.length - 1) ? "0px 0px 5px 0px" : "0px 0px 0px 0px"));
          return (
            <Hnd
              top = {`${ ((100 / handles.length) * index)-(index / handles.length)}%`}
              bottom = "unset"
              height = {`${(100 / handles.length)+(index / handles.length)}%`}
              borderRadius = { radius }
              isConnectable={isConnectable}
              onConnect={onConnect}
            />
          )
        })
      }
    </>

  );
}
